export type HullCleaningDashboardView = "voyage" | "cases" | "history";

export interface HullCleaningDashboard {
  voyageItinerary: HullCleaningVoyage[];
  cases: HullCleaningCase[];
  dryDocks: HullCleaningDryDock[];
  hullEvents: HullCleaningEvent[];
  refreshedAt: string | null;
}

export interface HullCleaningVoyage {
  imo: string | null;
  vesselName: string | null;
  voyageNo: string | null;
  uwicStatus: string | null;
  portName: string | null;
  portDays: number | null;
  eta: string | null;
  etd: string | null;
  arrDepStatus: string | null;
  portFunc: string | null;
  opsCoordinator: string | null;
  vesselType: string | null;
  voyageStatus: string | null;
  contractType: string | null;
  oprType: string | null;
  hempelApi: string | null;
  uncode: string | null;
  vs: string | null;
  hempelTier: number | null;
}

export interface HullCleaningCase {
  requestId: string;
  status: string | null;
  imo: string | null;
  vesselName: string | null;
  opsCoordinator: string | null;
  requestDate: string | null;
  reason: string | null;
  bookingDate: string | null;
  cleaningDate: string | null;
  cleaningPort: string | null;
  outcomeDate: string | null;
  outcome: string | null;
  dvpComment: string | null;
  voComment: string | null;
  vendor: string | null;
  vendorRef: string | null;
  lastUpdated: string | null;
}

export interface HullCleaningDryDock {
  imo: string | null;
  vesselName: string | null;
  date: string | null;
  nextDryDock: string | null;
  afAppliedDate: string | null;
  place: string | null;
  paintVendor: string | null;
  bt: string | null;
  fb: string | null;
  vs: string | null;
  paintScheme: string | null;
  propCoating: string | null;
  comment: string | null;
}

export interface HullCleaningEvent {
  eventId: string;
  requestId: string | null;
  imo: string | null;
  vesselName: string | null;
  date: string | null;
  event: string | null;
  place: string | null;
  vendor: string | null;
  comment: string | null;
}

export interface HullCleaningDashboardFilters {
  imo: string;
  vesselName: string;
  contractTypes: string[];
  voyageStatuses: string[];
  portDaysMin: string;
  portDaysMax: string;
  vesselType: string;
  arrDepStatuses: string[];
  opsCoordinator: string;
  oprTypes: string[];
  requestId: string;
  caseStatus: string;
  requestDateFrom: string;
  requestDateTo: string;
  bookingDate: string;
  lastUpdated: string;
  outcomeDate: string;
}

export type HullCleaningFilterSetter = <K extends keyof HullCleaningDashboardFilters>(
  name: K,
  value: HullCleaningDashboardFilters[K],
) => void;

export const EMPTY_HULL_CLEANING_FILTERS: HullCleaningDashboardFilters = {
  imo: "",
  vesselName: "",
  contractTypes: [],
  voyageStatuses: [],
  portDaysMin: "",
  portDaysMax: "",
  vesselType: "",
  arrDepStatuses: [],
  opsCoordinator: "",
  oprTypes: [],
  requestId: "",
  caseStatus: "",
  requestDateFrom: "",
  requestDateTo: "",
  bookingDate: "",
  lastUpdated: "",
  outcomeDate: "",
};
